import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from '@atlassian/jira-intl';
import search from './assets/search.svg';
import messages from './messages';

type Props = {
	shouldHideImage: boolean;
	onClick: () => void;
};

const AttachmentsError = ({ onClick, shouldHideImage }: Props) => {
	const { formatMessage } = useIntl();
	const imageUrl = !shouldHideImage ? search : undefined;
	const errorStatePrimaryAction = (
		<Button
			appearance="primary"
			onClick={() => onClick()}
			interactionName="auto-generated.jira-issue-attachments-table.ui.error.button"
		>
			{formatMessage(messages.primaryButton)}
		</Button>
	);

	return (
		<StyledEmptyState>
			<EmptyState
				imageUrl={imageUrl}
				header={formatMessage(messages.errorStateTitle)}
				description={formatMessage(messages.errorStateDescription)}
				primaryAction={errorStatePrimaryAction}
			/>
		</StyledEmptyState>
	);
};

AttachmentsError.defaultProps = {
	shouldHideImage: false,
};

export default AttachmentsError;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledEmptyState = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > div': {
		margin: 'auto',
	},
});
